import React from 'react'

export const closeOnEscapeKey = <T>(event: React.KeyboardEvent<HTMLElement>, setState: React.Dispatch<React.SetStateAction<T>>, newValue: T) => {
    if (event.code == 'Escape') {
        setState(newValue)
    }
}
